export const getFullUrlWithGetParams = (url: string, urlParams: Record<string, string>): string => {
  const fullUrl = new URL(url);
  Object.entries(urlParams).forEach(([key, value]) => {
    fullUrl.searchParams.append(key, value);
  });
  return fullUrl.toString();
};

export const isValidUrl = (url: string): boolean => {
  const urlRegex = /^https?:\/\/[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.\p{L}\p{N}]*$/u;
  return urlRegex.test(url);
};

export const ensureUrlProtocol = (value: string): string => {
  const url = value.trim();
  const isRelative = /^[/#?]/.test(url);
  const hostWithPort = /^[a-z\d.-]+:\d+(?:[/?#]|$)/i.test(url);
  const hasScheme = /^[a-z][a-z\d+.-]*:/i.test(url);
  return !url || isRelative || (hasScheme && !hostWithPort) ? url : `http://${url}`;
};

export const isValidDomain = (domain: string): boolean => {
  const domainRegex = /^[a-zA-Z0-9.-]+$/;
  return (
    domainRegex.test(domain) &&
    !domain.startsWith("-") &&
    !domain.endsWith("-") &&
    !domain.startsWith(".") &&
    !domain.endsWith(".")
  );
};

export const cleanUrl = (value: string): string => {
  return value.replace(/\s+/g, "").trim();
};

export const splitUrls = (value: string): string[] => {
  return value.split("\n").filter(line => line.length > 0);
};

export const cleanAndSplitUrls = (value: string): string[] => {
  return splitUrls(value)
    .map(cleanUrl)
    .filter(url => url.length > 0);
};

export const isUrlEmpty = (url: string): boolean => {
  return !url.trim();
};

export const hasMultipleProtocols = (url: string): boolean => {
  const protocolMatches = url.match(/https?:\/\//g);
  return protocolMatches ? protocolMatches.length > 1 : false;
};

export const trimUrl = (url: string): string => {
  return url.trim();
};

// Both helpers carry window.history.state forward instead of writing a blank
// state. Turbo stores its restoration identifier in the history state; a
// history entry without it makes Turbo treat a later popstate as
// historyPoppedWithEmptyState and fire turbo:before-cache outside any visit,
// which breaks widgets that tear themselves down on before-cache.
export const changeLocationHrefWithoutReload = (url: string): void => {
  window.history.pushState(window.history.state, "", url);
};

export const replaceLocationHrefWithoutReload = (url: string): void => {
  window.history.replaceState(window.history.state, "", url);
};
